module.exports = __webpack_public_path__ + "img/excel.89c01b32.svg";